import { defineNuxtPlugin, useRuntimeConfig } from "#app/nuxt";
import { useRequestURL } from "#app/composables/url";

// Résout le tenant depuis l'hôte et l'expose en `$tenant`.
// Écart assumé avec l'amont : on vise les modules qui définissent ces symboles, pas
// les barils `#imports` et `nuxt/app`, que le garde-fou de test interdit ici.
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const { hostname } = useRequestURL();

  const customDomains = (config.public.customDomains ?? {}) as Record<string, string>;
  const customDomain = customDomains[hostname];
  if (customDomain) {
    return { provide: { tenant: customDomain } };
  }

  const rootDomains = (config.public.rootDomains ?? []) as string[];
  const rootDomain = rootDomains.find(domain => hostname.endsWith(domain));
  if (!rootDomain) {
    return { provide: { tenant: "" } };
  }

  const tenant = config.public.strictSubdomains
    ? hostname.substring(0, hostname.indexOf(rootDomain) - 1)
    : hostname.split(".")[0];

  return { provide: { tenant } };
});
